exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#shortcutMenu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 20px 0 5px;\n  width: 42px;\n  height: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background-color: #595757;\n  color: white;\n  text-align: center;\n  font-size: 16px;\n  float: left;\n  position: relative;\n  z-index: 2100; \n}\n#shortcutMenu a {\n  color: white; \n}\n#shortcutMenu a:hover {\n  color: rgba(255, 255, 255, 0.5); \n}\n#shortcutMenu ul#shortcutIconBlock li {\n  margin-bottom: 15px; \n}\n#shortcutMenu svg.icon {\n  max-width: 30px;\n  font-size: 30px; \n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/menu/navbar/navbar.component.css
// module id = ../../../../../src/app/menu/navbar/navbar.component.css
// module chunks = main